import Comparison from './comparison'

export default Comparison